// extracted by mini-css-extract-plugin
module.exports = {"center":"Error_center__FfDGp","errorButton":"Error_errorButton__3NZcV"};